import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import WalletFilledSvg from "@ant-design/icons-svg/es/asn/WalletFilled";
import AntdIcon from "../components/AntdIcon";
var WalletFilled = function WalletFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: WalletFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  WalletFilled.displayName = 'WalletFilled';
}
export default /*#__PURE__*/React.forwardRef(WalletFilled);